
import { Sale, SaleRow } from "@/models/base";
import { Deposit } from "@/models/base/deposit";
import { SaleService } from "@/services/sale-service";
import { printHumanFloat } from "@/utils/pretty-print";
import { SaleEditState } from "@/utils/sale-edit/sale-edit-state";
import Vue from "vue";
import { IDataTableColumn } from "winfakt-vue-components";
export default Vue.extend({
	data(){
		return {
			isComputing: false
		};
	},
	props: {
		state: {
			type: Object as ()=>SaleEditState,
			required: true
		}
	},
	computed: {
		items():Deposit[] {
			return this.state.loadDepositsData.foundDeposits;
		},
		columns():IDataTableColumn[] {
			return [
				{
					name: this.$ct("deposit-invoice").toString(),
					property: "Sale.ComputedFriendlyID",
					width: "120px"
				},
				{
					name: this.$ct("deposit-amount").toString(),
					property: "Sale.TotalIncVAT",
					width: "120px",
					print(value:number):string{
						return printHumanFloat(value);
					}
				},
				{
					name: this.$ct("deposit-created-by-document").toString(),
					property: "SaleCreatedByDocumentNr",
					width: "400px"
				},
			];
		},
		cardStyle():any {
			if (this.$wf.isMdUp) {
				return {
					maxWidth: "95%",
					marginTop: "20px",
					marginBottom: "20px",
				};
			}
			return {
				maxWidth: "100%",
				marginTop: "0",
				marginBottom: "0"
			};
		},
		confirmDisabled():boolean {
			if (this.isComputing) {
				return true;
			}
			return this.state.loadDepositsData.selectedDeposits.length == 0;
		}
	},
	methods: {
		close(){
			this.state.loadDepositsData.modal = false;
		},
		async confirm(){
			if (this.isComputing) return;
			this.isComputing = true;
			try{
				for (let deposit of this.state.loadDepositsData.selectedDeposits) {
					let sale = await SaleService.getSale(deposit.SaleID);
					await this.createRows(deposit, sale);
				}
				this.state.sale.calculateTotals();
				this.state.loadDepositsData.modal = false;
			}catch(err){}
			this.isComputing = true;
		},
		async createRows(deposit:Deposit, sale:Sale) {
			let docTypeName = sale.Type.Name.getTranslation(this.state.sale.getLng());
			let firstRow = true;
			for (let row of sale.Rows) {
				let newRow = new SaleRow();
				if (firstRow) {
					newRow.DepositIDs = [deposit.ID];
				}
				firstRow = false;
				newRow.Amount = -row.Amount;
				newRow.Amount1 = -row.Amount1;
				newRow.Amount2 = row.Amount2;
				newRow.UnitPrice = row.UnitPrice;
				newRow.Vat = row.Vat;
				newRow.ProductDescription = this.$ct("to-pay-invoice-of-deposit", {docType: docTypeName, number: sale.ComputedFriendlyID}).toString();
				newRow.calculateTotals(this.state.sale);
				this.state.sale.Rows.push(newRow);
			}
		}
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
